import React from 'react'
import PropTypes from 'prop-types'
import ReadDocs from './ReadDocs'
import OptIn from './OptIn'
import PayDeposit from './PayDeposit'
import Download from './Download'

export default function BecomeFPSteps ( props : {pageCount : number}) : JSX.Element {
  let component = <></>
  switch(props.pageCount) {
  case 0:
    component = <ReadDocs />
    break;
  case 1:
    component = <OptIn />
    break;
  case 2:
    component = <PayDeposit />
    break;
  case 3:
    component = <Download />
    break;
  }
  return component;
}

BecomeFPSteps.propTypes = {
  pageCount: PropTypes.number,
};

BecomeFPSteps.defaultProps = {
  pageCount: 0
};